const CHAT_SESSION_KEY = 'chat_session';

export const chatStorage = {
  saveSession(sessionData) {
    try {
      localStorage.setItem(CHAT_SESSION_KEY, JSON.stringify(sessionData));
    } catch (error) {
      console.error('Failed to save chat session:', error);
    }
  },

  getSession() {
    try {
      const data = localStorage.getItem(CHAT_SESSION_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Failed to retrieve chat session:', error);
      return null;
    }
  },

  clearSession() {
    try {
      localStorage.removeItem(CHAT_SESSION_KEY);
    } catch (error) {
      console.error('Failed to clear chat session:', error);
    }
  },

  hasActiveSession() {
    const session = this.getSession();
    return session && session.status === 'active';
  }
};
